import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';

const OptionSingle = ({ description, retail }) => {
    return (
        <li>
            <span className="is-light">{description}</span>
            <span className={retail < 0 ? 'sr-text is-bold is-price' : 'sr-text is-bold'}>
                {LocaleService.l(retail, CurrencyFormats.CURRENCY_0)}
            </span>
        </li>
    );
};

OptionSingle.propTypes = {
    description: PropTypes.string.isRequired,
    retail: PropTypes.number.isRequired,
};

OptionSingle.displayName = 'OptionSingle';

export default OptionSingle;
